import React, { useState, useEffect, useCallback, useRef } from "react";
import "./Dashboard.css";
import { useAuth } from "../../context/AuthContext";
import { dashboardService, jobsService } from "../../services";

// Icon Components
const IconDeliveries = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 16h6"/>
    <path d="M19 13v6"/>
    <path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"/>
    <path d="m7.5 4.27 9 5.15"/>
    <polyline points="3.29 7 12 12 20.71 7"/>
    <line x1="12" x2="12" y1="22" y2="12"/>
  </svg>
);

const IconExceptions = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" x2="12" y1="8" y2="12"/>
    <line x1="12" x2="12.01" y1="16" y2="16"/>
  </svg>
);

const IconDrivers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.5 2.8C1.4 11.3 1 12.1 1 13v3c0 .6.4 1 1 1h2"/>
    <circle cx="7" cy="17" r="2"/>
    <path d="M9 17h6"/>
    <circle cx="17" cy="17" r="2"/>
  </svg>
);

const IconOfflineDrivers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

const IconPending = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2v4"/>
    <path d="m16.2 7.8 2.9-2.9"/>
    <path d="M18 12h4"/>
    <path d="m16.2 16.2 2.9 2.9"/>
    <path d="M12 18v4"/>
    <path d="m4.9 19.1 2.9-2.9"/>
    <path d="M2 12h4"/>
    <path d="m4.9 4.9 2.9 2.9"/>
  </svg>
);

const IconInTransit = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"/>
    <path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"/>
    <circle cx="7" cy="18" r="2"/>
    <path d="M15 18H9"/>
    <circle cx="17" cy="18" r="2"/>
  </svg>
);

const IconUsers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const IconReviews = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

const IconTrend = ({ isPositive }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke={isPositive ? "#22c55e" : "#dc2626"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {isPositive ? (
      <>
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
        <polyline points="17 6 23 6 23 12"/>
      </>
    ) : (
      <>
        <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/>
        <polyline points="17 18 23 18 23 12"/>
      </>
    )}
  </svg>
);

const IconCalendar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/>
    <line x1="16" x2="16" y1="2" y2="6"/>
    <line x1="8" x2="8" y1="2" y2="6"/>
    <line x1="3" x2="21" y1="10" y2="10"/>
  </svg>
);

const IconChart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" x2="12" y1="20" y2="10"/>
    <line x1="18" x2="18" y1="20" y2="4"/>
    <line x1="6" x2="6" y1="20" y2="16"/>
  </svg>
);

// Loading Spinner Component
const LoadingSpinner = () => (
  <div className="mq-loading-spinner">
    <div className="mq-spinner"></div>
  </div>
);

// Status badge helper
const getStatusClass = (status) => {
  const statusMap = {
    'Pending': 'mq-pill-yellow',
    'Assigned': 'mq-pill-blue',
    'In Transit': 'mq-pill-blue',
    'Delivered': 'mq-pill-green',
    'Exception': 'mq-pill-red',
    'Cancelled': 'mq-pill-grey',
  };
  return statusMap[status] || 'mq-pill-grey';
};

// Circular Progress Component
const CircularProgress = ({ value, size = 120, strokeWidth = 10, label }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className="mq-circular-progress" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <circle
          className="mq-circular-bg"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className="mq-circular-fill"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div className="mq-circular-content">
        <span className="mq-circular-value">{value}%</span>
        {label && <span className="mq-circular-label">{label}</span>}
      </div>
    </div>
  );
};

// Mini Stat Card Component
const MiniStatCard = ({ icon, value, label, trend, color = "blue" }) => (
  <div className={`mq-mini-stat mq-mini-stat-${color}`}>
    <div className="mq-mini-stat-icon">{icon}</div>
    <div className="mq-mini-stat-content">
      <div className="mq-mini-stat-value">{value}</div>
      <div className="mq-mini-stat-label">{label}</div>
    </div>
    {trend !== undefined && (
      <div className={`mq-mini-stat-trend ${trend >= 0 ? 'positive' : 'negative'}`}>
        <IconTrend isPositive={trend >= 0} />
        <span>{trend >= 0 ? '+' : ''}{trend}%</span>
      </div>
    )}
  </div>
);

export default function Dashboard() {
  const { user } = useAuth();

  // State
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [kpis, setKpis] = useState({
    totalDeliveries: 0,
    exceptionsToday: 0,
    activeDrivers: 0,
    nonActiveDrivers: 0,
    overallProgress: 0,
    pendingJobs: 0,
    inTransitJobs: 0,
    assignedJobs: 0,
  });
  const [comprehensiveStats, setComprehensiveStats] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [jobsPage, setJobsPage] = useState(1);
  const [totalJobPages, setTotalJobPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  // Company filter state
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);

  // Export state
  const [showExportModal, setShowExportModal] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [exportError, setExportError] = useState(null);

  // Refs
  const companyDropdownRef = useRef(null);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (companyDropdownRef.current && !companyDropdownRef.current.contains(event.target)) {
        setShowCompanyDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fetch companies for filter
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const data = await dashboardService.getCompaniesForFilter();
        setCompanies(data);
      } catch (err) {
        console.error('Error fetching companies:', err);
      }
    };
    fetchCompanies();
  }, []);

  // Fetch dashboard data
  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const companyFilter = selectedCompany || null;

      // Fetch all data in parallel
      const [kpisData, statsData, driversData, jobsData] = await Promise.all([
        dashboardService.getAdminKPIs(companyFilter).catch(() => null),
        dashboardService.getComprehensiveStats(companyFilter).catch(() => null),
        dashboardService.getDriversStatus(5, companyFilter).catch(() => []),
        jobsService.getJobs({ page: jobsPage, limit: 5, company: companyFilter }).catch(() => ({ jobs: [], pagination: {} })),
      ]);

      if (kpisData?.kpis) {
        setKpis(kpisData.kpis);
      }

      if (statsData) {
        setComprehensiveStats(statsData);
      }

      if (driversData?.drivers) {
        setDrivers(driversData.drivers);
      } else if (Array.isArray(driversData)) {
        setDrivers(driversData);
      }

      if (jobsData) {
        setJobs(jobsData.jobs || []);
        setTotalJobPages(jobsData.pagination?.totalPages || 1);
      }

    } catch (err) {
      console.error('Dashboard fetch error:', err);
      setError('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  }, [jobsPage, selectedCompany]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  // Format job ID
  const formatJobId = (job) => {
    return `#${job.jobNumber || job._id?.slice(-4) || '0000'}`;
  };

  // Get display name
  const getUserDisplayName = () => {
    if (user?.firstName) {
      return `${user.firstName} ${user.lastName || ''}`.trim();
    }
    return user?.email?.split('@')[0] || 'Admin';
  };

  // Get selected company name
  const getSelectedCompanyName = () => {
    if (!selectedCompany) return 'All Companies';
    const company = companies.find(c => c._id === selectedCompany);
    return company?.name || 'All Companies';
  };

  // Handle company selection
  const handleCompanySelect = (companyId) => {
    setSelectedCompany(companyId);
    setShowCompanyDropdown(false);
  };

  // Export functions
  const exportToPDF = async () => {
    setExporting(true);
    setExportError(null);
    try {
      const data = await dashboardService.getExportData({ company: selectedCompany });

      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
        <head>
          <title>Dashboard Report - ${data.company}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 40px; color: #333; }
            h1 { color: #282440; border-bottom: 2px solid #FFDB6B; padding-bottom: 10px; }
            h2 { color: #282440; margin-top: 30px; }
            .header-info { color: #666; margin-bottom: 20px; }
            .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; margin: 20px 0; }
            .stat-card { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 20px; text-align: center; }
            .stat-value { font-size: 32px; font-weight: 600; color: #282440; }
            .stat-label { color: #666; margin-top: 5px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #e5e7eb; padding: 12px; text-align: left; }
            th { background: #f9fafb; font-weight: 600; }
            .footer { margin-top: 40px; text-align: center; color: #666; font-size: 12px; }
          </style>
        </head>
        <body>
          <h1>Dashboard Report</h1>
          <div class="header-info">
            <p><strong>Company:</strong> ${data.company}</p>
            <p><strong>Date Range:</strong> ${data.dateRange.start} to ${data.dateRange.end}</p>
            <p><strong>Generated:</strong> ${new Date(data.generatedAt).toLocaleString()}</p>
          </div>
          <h2>Summary Statistics</h2>
          <div class="stats-grid">
            <div class="stat-card"><div class="stat-value">${data.stats.summary.totalJobs}</div><div class="stat-label">Total Jobs</div></div>
            <div class="stat-card"><div class="stat-value">${data.stats.summary.totalUsers}</div><div class="stat-label">Total Users</div></div>
            <div class="stat-card"><div class="stat-value">${data.stats.summary.totalDrivers}</div><div class="stat-label">Total Drivers</div></div>
            <div class="stat-card"><div class="stat-value">${data.stats.summary.averageRating}</div><div class="stat-label">Average Rating</div></div>
          </div>
          <h2>Job Status Breakdown</h2>
          <div className="mq-table-scroll"><table>
            <tr><th>Status</th><th>Count</th></tr>
            ${Object.entries(data.stats.jobs.statusBreakdown).map(([status, count]) => `<tr><td>${status}</td><td>${count}</td></tr>`).join('')}
          </table></div>
          <h2>Recent Jobs (${data.jobs.length})</h2>
          <div className="mq-table-scroll"><table>
            <tr><th>Job #</th><th>Status</th><th>Client</th><th>Driver</th><th>Created</th></tr>
            ${data.jobs.slice(0, 20).map(job => `<tr><td>${job.jobNumber}</td><td>${job.status}</td><td>${job.client}</td><td>${job.driver}</td><td>${new Date(job.createdAt).toLocaleDateString()}</td></tr>`).join('')}
          </table></div>
          <div class="footer"><p>Generated by Marquee Couriers Admin Dashboard</p></div>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } catch (err) {
      setExportError('Failed to generate PDF');
    } finally {
      setExporting(false);
    }
  };

  const exportToExcel = async () => {
    setExporting(true);
    setExportError(null);
    try {
      const data = await dashboardService.getExportData({ company: selectedCompany });

      let csv = 'Dashboard Export Report\n';
      csv += `Company,${data.company}\n`;
      csv += `Date Range,${data.dateRange.start} to ${data.dateRange.end}\n`;
      csv += `Generated,${new Date(data.generatedAt).toLocaleString()}\n\n`;
      csv += 'Summary Statistics\n';
      csv += `Total Jobs,${data.stats.summary.totalJobs}\n`;
      csv += `Total Users,${data.stats.summary.totalUsers}\n`;
      csv += `Total Drivers,${data.stats.summary.totalDrivers}\n`;
      csv += `Average Rating,${data.stats.summary.averageRating}\n\n`;
      csv += 'Job Status Breakdown\nStatus,Count\n';
      Object.entries(data.stats.jobs.statusBreakdown).forEach(([status, count]) => {
        csv += `${status},${count}\n`;
      });
      csv += '\nJobs Detail\nJob Number,Status,Priority,Client,Driver,Created At\n';
      data.jobs.forEach(job => {
        csv += `${job.jobNumber},${job.status},${job.priority || 'Normal'},"${job.client}","${job.driver}",${job.createdAt}\n`;
      });

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `dashboard_report_${new Date().toISOString().split('T')[0]}.csv`;
      link.click();
      setShowExportModal(false);
    } catch (err) {
      setExportError('Failed to generate CSV');
    } finally {
      setExporting(false);
    }
  };

  const printDashboard = () => {
    window.print();
    setShowExportModal(false);
  };

  // Get current date formatted
  const getCurrentDate = () => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date().toLocaleDateString('en-US', options);
  };

  if (loading && jobs.length === 0) {
    return (
      <div className="mq-dashboard mq-dashboard-loading">
        <LoadingSpinner />
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="mq-dashboard">
      {/* Error message */}
      {error && (
        <div className="mq-dashboard-error">
          <span>{error}</span>
          <button onClick={fetchDashboardData}>Retry</button>
        </div>
      )}

      {/* HEADER SECTION */}
      <section className="mq-dashboard-header">
        <div className="mq-dashboard-header-top">
          <div className="mq-welcome-block">
            <div className="mq-welcome-label">Welcome Back,</div>
            <h1 className="mq-welcome-name">{getUserDisplayName()}</h1>
            <div className="mq-welcome-date">
              <IconCalendar />
              <span>{getCurrentDate()}</span>
            </div>
          </div>

          <div className="mq-header-actions">
            {/* Company Filter Dropdown */}
            <div className="mq-dropdown-container" ref={companyDropdownRef}>
              <button
                className="mq-btn mq-btn-outline"
                onClick={() => setShowCompanyDropdown(!showCompanyDropdown)}
              >
                {getSelectedCompanyName()} <span className="mq-caret">▾</span>
              </button>
              {showCompanyDropdown && (
                <div className="mq-dropdown-menu">
                  <div
                    className={`mq-dropdown-item ${!selectedCompany ? 'active' : ''}`}
                    onClick={() => handleCompanySelect('')}
                  >
                    All Companies
                  </div>
                  {companies.map(company => (
                    <div
                      key={company._id}
                      className={`mq-dropdown-item ${selectedCompany === company._id ? 'active' : ''}`}
                      onClick={() => handleCompanySelect(company._id)}
                    >
                      {company.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button
              className="mq-btn mq-btn-primary mq-btn-export"
              onClick={() => setShowExportModal(true)}
            >
              <IconChart />
              Export Report
            </button>
          </div>
        </div>
      </section>

      {/* OVERVIEW SECTION - Progress + Quick Stats */}
      <section className="mq-overview-section">
        <div className="mq-card mq-overview-card">
          <div className="mq-overview-left">
            <CircularProgress
              value={kpis.overallProgress}
              size={140}
              strokeWidth={12}
              label="Completion"
            />
          </div>
          <div className="mq-overview-right">
            <h3 className="mq-overview-title">
              <IconChart />
              Delivery Overview
            </h3>
            <p className="mq-overview-subtitle">
              {kpis.overallProgress > 0
                ? `${kpis.overallProgress}% of jobs completed this period`
                : 'No deliveries recorded yet'}
            </p>
            <div className="mq-overview-stats">
              <div className="mq-overview-stat">
                <span className="mq-overview-stat-value">{kpis.totalDeliveries}</span>
                <span className="mq-overview-stat-label">Delivered Today</span>
              </div>
              <div className="mq-overview-stat">
                <span className="mq-overview-stat-value">{kpis.pendingJobs || 0}</span>
                <span className="mq-overview-stat-label">Pending</span>
              </div>
              <div className="mq-overview-stat">
                <span className="mq-overview-stat-value">{kpis.inTransitJobs || 0}</span>
                <span className="mq-overview-stat-label">In Transit</span>
              </div>
              <div className="mq-overview-stat mq-stat-exception">
                <span className="mq-overview-stat-value">{kpis.exceptionsToday}</span>
                <span className="mq-overview-stat-label">Exceptions</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QUICK STATS ROW */}
      <section className="mq-quick-stats">
        <MiniStatCard
          icon={<IconDeliveries />}
          value={comprehensiveStats?.jobs?.total || 0}
          label="Total Jobs"
          color="blue"
        />
        <MiniStatCard
          icon={<IconDrivers />}
          value={kpis.activeDrivers}
          label="Active Drivers"
          color="green"
        />
        <MiniStatCard
          icon={<IconOfflineDrivers />}
          value={kpis.nonActiveDrivers}
          label="Offline Drivers"
          color="grey"
        />
        <MiniStatCard
          icon={<IconPending />}
          value={kpis.pendingJobs || 0}
          label="Pending Jobs"
          color="yellow"
        />
        <MiniStatCard
          icon={<IconInTransit />}
          value={kpis.inTransitJobs || 0}
          label="In Transit"
          color="purple"
        />
        <MiniStatCard
          icon={<IconExceptions />}
          value={kpis.exceptionsToday}
          label="Exceptions"
          color="red"
        />
      </section>

      {/* COMPREHENSIVE STATS SECTION */}
      {comprehensiveStats && (
        <section className="mq-stats-row">
          {/* Jobs Stats Card */}
          <div className="mq-card mq-stats-card">
            <div className="mq-stats-card-header">
              <div className="mq-card-title">
                <IconDeliveries />
                Job Statistics
              </div>
              <div className={`mq-trend ${comprehensiveStats.jobs.trend >= 0 ? 'positive' : 'negative'}`}>
                <IconTrend isPositive={comprehensiveStats.jobs.trend >= 0} />
                <span>{comprehensiveStats.jobs.trend >= 0 ? '+' : ''}{comprehensiveStats.jobs.trend}%</span>
              </div>
            </div>
            <div className="mq-stats-grid">
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.jobs.total}</span>
                <span className="mq-stat-label">Total</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.jobs.today}</span>
                <span className="mq-stat-label">Today</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.jobs.thisWeek}</span>
                <span className="mq-stat-label">This Week</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.jobs.thisMonth}</span>
                <span className="mq-stat-label">This Month</span>
              </div>
            </div>
            <div className="mq-status-breakdown">
              <div className="mq-breakdown-title">Status Breakdown</div>
              <div className="mq-breakdown-items">
                {Object.entries(comprehensiveStats.jobs.statusBreakdown).map(([status, count]) => (
                  <div key={status} className="mq-breakdown-item">
                    <span className={`mq-pill ${getStatusClass(status)}`}>{status}</span>
                    <span className="mq-breakdown-count">{count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Users & Drivers Stats Card */}
          <div className="mq-card mq-stats-card">
            <div className="mq-stats-card-header">
              <div className="mq-card-title">
                <IconUsers />
                Users & Drivers
              </div>
              <div className={`mq-trend ${comprehensiveStats.users.trend >= 0 ? 'positive' : 'negative'}`}>
                <IconTrend isPositive={comprehensiveStats.users.trend >= 0} />
                <span>{comprehensiveStats.users.trend >= 0 ? '+' : ''}{comprehensiveStats.users.trend}%</span>
              </div>
            </div>
            <div className="mq-stats-grid">
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.users.total}</span>
                <span className="mq-stat-label">Total Users</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.users.active}</span>
                <span className="mq-stat-label">Active</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.drivers.total}</span>
                <span className="mq-stat-label">Drivers</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.drivers.online}</span>
                <span className="mq-stat-label">Online</span>
              </div>
            </div>
            <div className="mq-users-by-role">
              <div className="mq-breakdown-title">Users by Role</div>
              <div className="mq-role-items">
                {Object.entries(comprehensiveStats.users.byRole || {}).slice(0, 4).map(([role, count]) => (
                  <div key={role} className="mq-role-item">
                    <span className="mq-role-name">{role || 'Unknown'}</span>
                    <span className="mq-role-count">{count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Reviews Stats Card */}
          <div className="mq-card mq-stats-card">
            <div className="mq-stats-card-header">
              <div className="mq-card-title">
                <IconReviews />
                Reviews & Ratings
              </div>
              <div className="mq-rating-badge">
                <span className="mq-rating-star">★</span>
                <span>{comprehensiveStats.reviews.averageRating || 0}</span>
              </div>
            </div>
            <div className="mq-stats-grid">
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.reviews.total}</span>
                <span className="mq-stat-label">Total</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.reviews.recentCount}</span>
                <span className="mq-stat-label">This Month</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.reviews.flaggedCount}</span>
                <span className="mq-stat-label">Flagged</span>
              </div>
              <div className="mq-stat-item">
                <span className="mq-stat-value">{comprehensiveStats.jobs.deliverySuccessRate}%</span>
                <span className="mq-stat-label">Success</span>
              </div>
            </div>
            <div className="mq-rating-distribution">
              <div className="mq-breakdown-title">Rating Distribution</div>
              <div className="mq-rating-bars">
                {[5, 4, 3, 2, 1].map(rating => {
                  const count = comprehensiveStats.reviews.distribution?.[rating] || 0;
                  const total = comprehensiveStats.reviews.total || 1;
                  const percent = Math.round((count / total) * 100) || 0;
                  return (
                    <div key={rating} className="mq-rating-bar-row">
                      <span className="mq-rating-stars">{rating}★</span>
                      <div className="mq-rating-bar-container">
                        <div className="mq-rating-bar-fill" style={{ width: `${percent}%` }} />
                      </div>
                      <span className="mq-rating-count">{count}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Activity Trends Chart */}
      {comprehensiveStats?.activityTrends && (
        <section className="mq-card mq-chart-card">
          <div className="mq-card-header-inline">
            <div className="mq-card-title">
              <IconChart />
              Activity Trends (Last 7 Days)
            </div>
            <div className="mq-chart-legend">
              <span className="mq-legend-item"><span className="mq-dot mq-dot-primary" /> Jobs</span>
              <span className="mq-legend-item"><span className="mq-dot mq-dot-green" /> Deliveries</span>
              <span className="mq-legend-item"><span className="mq-dot mq-dot-accent" /> Exceptions</span>
            </div>
          </div>
          <div className="mq-chart-area">
            <div className="mq-chart-grid">
              {comprehensiveStats.activityTrends.map((day, index) => {
                const maxValue = Math.max(
                  ...comprehensiveStats.activityTrends.map(d => Math.max(d.jobs, d.deliveries, d.exceptions)),
                  1
                );
                return (
                  <div key={index} className="mq-chart-bar-wrap">
                    <div className="mq-chart-bars-group">
                      <div
                        className="mq-chart-bar mq-chart-bar-primary"
                        style={{ height: `${Math.max((day.jobs / maxValue) * 120, 4)}px` }}
                        title={`Jobs: ${day.jobs}`}
                      >
                        <span className="mq-bar-tooltip">{day.jobs}</span>
                      </div>
                      <div
                        className="mq-chart-bar mq-chart-bar-green"
                        style={{ height: `${Math.max((day.deliveries / maxValue) * 120, 4)}px` }}
                        title={`Deliveries: ${day.deliveries}`}
                      >
                        <span className="mq-bar-tooltip">{day.deliveries}</span>
                      </div>
                      <div
                        className="mq-chart-bar mq-chart-bar-accent"
                        style={{ height: `${Math.max((day.exceptions / maxValue) * 120, 4)}px` }}
                        title={`Exceptions: ${day.exceptions}`}
                      >
                        <span className="mq-bar-tooltip">{day.exceptions}</span>
                      </div>
                    </div>
                    <span className="mq-chart-day-label">{day.dayName}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* BOTTOM SECTION: Drivers + Jobs */}
      <section className="mq-bottom-row">
        {/* DRIVERS CARD */}
        <div className="mq-card mq-drivers-card">
          <div className="mq-card-header-inline">
            <div className="mq-card-title">
              <IconDrivers />
              Active Drivers
            </div>
            <a href="/drivers" className="mq-view-all">View All →</a>
          </div>
          {drivers.length === 0 ? (
            <div className="mq-empty-state">
              <IconDrivers />
              <p>No drivers available</p>
            </div>
          ) : (
            <ul className="mq-drivers-list">
              {drivers.map((driver) => (
                <li key={driver.id || driver._id} className="mq-driver-row">
                  <div className="mq-driver-main">
                    <div className="mq-driver-avatar">
                      {driver.avatar ? (
                        <img src={driver.avatar} alt={driver.name} />
                      ) : (
                        <div className="mq-driver-avatar-placeholder">
                          {driver.name?.charAt(0) || 'D'}
                        </div>
                      )}
                      <span className={`mq-driver-status-dot ${driver.status === 'Online' ? 'online' : 'offline'}`} />
                    </div>
                    <div className="mq-driver-info">
                      <div className="mq-driver-name">{driver.name}</div>
                      <div className="mq-driver-route">
                        {driver.vehicle || 'No vehicle assigned'}
                      </div>
                    </div>
                  </div>
                  <div className="mq-driver-right">
                    <div className="mq-driver-rating">
                      <span className="mq-rating-star">★</span> {driver.rating?.toFixed(1) || '0.0'}
                    </div>
                    <span className={`mq-pill mq-driver-status ${driver.status === 'Online' ? 'mq-pill-green' : 'mq-pill-grey'}`}>
                      {driver.status || 'Offline'}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* TODAY'S JOBS CARD */}
        <div className="mq-card mq-jobs-card">
          <div className="mq-jobs-header-row">
            <div className="mq-card-title">
              <IconDeliveries />
              Recent Jobs
            </div>
            <div className="mq-jobs-controls">
              <div className="mq-jobs-search">
                <span className="mq-jobs-search-icon">🔍</span>
                <input
                  className="mq-jobs-search-input"
                  placeholder="Search jobs..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <a href="/jobs" className="mq-btn mq-btn-new-job">View All</a>
            </div>
          </div>

          {jobs.length === 0 ? (
            <div className="mq-empty-state mq-jobs-empty">
              <IconDeliveries />
              <p>No jobs found</p>
              <small>Jobs will appear here</small>
            </div>
          ) : (
            <>
              <div className="mq-table-scroll"><table className="mq-table mq-jobs-table">
                <thead>
                  <tr>
                    <th>Job #</th>
                    <th>Client</th>
                    <th>Route</th>
                    <th>Priority</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {jobs.map((job) => (
                    <tr key={job._id}>
                      <td><strong>{formatJobId(job)}</strong></td>
                      <td>
                        {job.client?.firstName
                          ? `${job.client.firstName} ${job.client.lastName || ''}`
                          : job.company?.name || 'N/A'
                        }
                      </td>
                      <td className="mq-route-cell">
                        <span className="mq-route-text">
                          {job.pickup?.address?.substring(0, 15) || 'N/A'} → {job.delivery?.address?.substring(0, 15) || 'N/A'}
                        </span>
                      </td>
                      <td>
                        <span className={`mq-pill ${job.priority === 'Urgent' ? 'mq-pill-red' : 'mq-pill-grey'}`}>
                          {job.priority || 'Normal'}
                        </span>
                      </td>
                      <td>
                        <span className={`mq-pill ${getStatusClass(job.status)}`}>
                          {job.status || 'Pending'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table></div>

              <div className="jobs-footer-section">
                <span className="jobs-footer-text">Page {jobsPage} of {totalJobPages}</span>
                <div className="jobs-pagination-controls">
                  <button
                    className="jobs-pagination-btn"
                    onClick={() => setJobsPage(p => Math.max(1, p - 1))}
                    disabled={jobsPage <= 1}
                  >
                    ← Prev
                  </button>
                  <button
                    className="jobs-pagination-btn"
                    onClick={() => setJobsPage(p => Math.min(totalJobPages, p + 1))}
                    disabled={jobsPage >= totalJobPages}
                  >
                    Next →
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </section>

      {/* Export Modal */}
      {showExportModal && (
        <div className="mq-modal-overlay" onClick={() => setShowExportModal(false)}>
          <div className="mq-modal" onClick={e => e.stopPropagation()}>
            <div className="mq-modal-header">
              <h2>Export Report</h2>
              <button className="mq-modal-close" onClick={() => setShowExportModal(false)}>×</button>
            </div>
            <div className="mq-modal-body">
              <p className="mq-export-info">
                Export dashboard data for <strong>{getSelectedCompanyName()}</strong>
              </p>

              {exportError && <div className="mq-export-error">{exportError}</div>}

              <div className="mq-export-options">
                <button className="mq-export-option" onClick={exportToPDF} disabled={exporting}>
                  <span className="mq-export-icon">📄</span>
                  <div>
                    <span className="mq-export-label">PDF Report</span>
                    <span className="mq-export-desc">Generate printable PDF</span>
                  </div>
                </button>

                <button className="mq-export-option" onClick={exportToExcel} disabled={exporting}>
                  <span className="mq-export-icon">📊</span>
                  <div>
                    <span className="mq-export-label">Excel/CSV</span>
                    <span className="mq-export-desc">Download spreadsheet</span>
                  </div>
                </button>

                <button className="mq-export-option" onClick={printDashboard} disabled={exporting}>
                  <span className="mq-export-icon">🖨️</span>
                  <div>
                    <span className="mq-export-label">Print</span>
                    <span className="mq-export-desc">Print current view</span>
                  </div>
                </button>
              </div>

              {exporting && (
                <div className="mq-export-loading">
                  <LoadingSpinner />
                  <span>Generating...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
